module.exports = __webpack_public_path__ + "static/img/6.7a12c25.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/zh/6.png
// module id = ltwR
// module chunks = 0